import React from 'react';
import PropTypes from 'prop-types';

const UserGroupPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M9.714 10.286A6.284 6.284 0 0 0 16 16.57a6.286 6.286 0 1 0-6.286-6.284zm13.452-4.164a8.252 8.252 0 0 1 1.118 4.164c0 1.988-.7 3.814-1.868 5.242.444.218.864.46 1.256.722a5.144 5.144 0 1 0-.506-10.128zM2.572 11.144a5.142 5.142 0 0 0 5.754 5.106c.394-.262.814-.504 1.256-.722a8.252 8.252 0 0 1-1.868-5.242c0-1.518.408-2.94 1.122-4.164a5.144 5.144 0 0 0-6.264 5.022zm22.892 6.648c1.25 1.4 1.966 3.13 1.966 5.066 0 .388-.008.772-.018 1.142h3.496c.554 0 1.024-.436 1.05-1.018 0 0 .042-.572.042-1.554 0-2.184-1.52-3.892-3.788-4.794a6.722 6.722 0 0 1-2.748 1.158zM0 21.428c0 .986.046 1.556.046 1.556A1.07 1.07 0 0 0 1.1 24h3.49a35.4 35.4 0 0 1-.018-1.142c0-1.936.712-3.666 1.964-5.066a6.765 6.765 0 0 1-2.75-1.158C1.52 17.536 0 19.244 0 21.428zm16-2.892c-1.79 0-3.448-.57-4.8-1.538-2.772 1.1-4.63 3.188-4.63 5.86 0 1.202.07 2.138.07 2.138.03.554.516 1.004 1.056 1.004h16.62a1.06 1.06 0 0 0 1.05-1.006s.062-.938.062-2.136c0-2.672-1.858-4.76-4.628-5.86a8.219 8.219 0 0 1-4.8 1.538z"
    />
  );
};

UserGroupPath.propTypes = {
  fill: PropTypes.string,
};

export default UserGroupPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/user/user-group.jsx